import { ContentPreviewer } from '@shared/components';

import { useParseQuestionContent } from '../../hooks';

interface SingleQuestionReviewContentPreviewerProps {
  content: string;
  questionId: string;
  taskId: string;
}

interface ItemSetQuestionReviewContentPreviewerProps {
  content: string;
  questionGroupId: string;
  taskId: string;
}

type QuestionReviewContentPreviewerProps =
  | SingleQuestionReviewContentPreviewerProps
  | ItemSetQuestionReviewContentPreviewerProps;

export default function QuestionReviewContentPreviewer(
  props: Readonly<QuestionReviewContentPreviewerProps>,
) {
  const { content, taskId, ...restProps } = props;
  const { content: parsedContent } = useParseQuestionContent({
    content,
    taskId,
    ...restProps,
  });

  return <ContentPreviewer content={parsedContent} />;
}
